/**
 * Canonical hex colour for each Riftbound domain.
 * Sampled from `public/domain-icons/*.png` (official glyph fills).
 */
export const DOMAIN_HEX: Record<string, string> = {
  Body:  '#e1700b',
  Calm:  '#15a971',
  Chaos: '#6a4890',
  Fury:  '#ca202d',
  Mind:  '#217799',
  Order: '#cca901',
};

/** Convert a hex colour + alpha to a CSS rgba() string. */
export function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}
